import axios from 'axios';

export const getMessages = cursor => axios.get('/notifications/notification/?cursor', { params: { cursor } });

export const readMessage = id => axios.post(`/notifications/notification/${id}/mark_read/`);

export const deleteMessage = id => axios.delete(`/notifications/notification/${id}/`);
